export interface FreefieldProfileFilterType {
  freefieldProfiles: server.dto.FreeFieldProfileSmall[]
}

export const initialFreefieldProfileFilter: FreefieldProfileFilterType = {
  freefieldProfiles: []
}
